// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wYfcNQ0q2BtMVa6uUysSV{display:flex;justify-content:center;align-items:center}.wYfcNQ0q2BtMVa6uUysSV ._10ppHYncH43r-aCeyQL8ej{padding:4px 6px;width:46px;height:24px;background:#f8f8f8;border-radius:18px;font-family:\"Mulish\",sans-serif;font-style:normal;font-weight:700;font-size:10px;line-height:16px;color:#131a4f;text-align:center;margin-right:12px}.wYfcNQ0q2BtMVa6uUysSV ._10ppHYncH43r-aCeyQL8ej.DVIOK4gHZYPNR9eawSG2m{background:#e3f9e1;color:#3aaa35}.wYfcNQ0q2BtMVa6uUysSV ._17GIJnwlTJLqnj3f8ucG__{display:flex;width:100%;height:4px;border-radius:10px;background-color:#ecedf5;overflow:hidden}.wYfcNQ0q2BtMVa6uUysSV ._17GIJnwlTJLqnj3f8ucG__ .Cwn2rKtnmjwQXNgFAogDM{height:100%;background-color:#3aaa35}.wYfcNQ0q2BtMVa6uUysSV ._17GIJnwlTJLqnj3f8ucG__ ._2lBAg9wc3mNukRQnv_CLif{height:100%;background-color:#ff4141}\n", ""]);
// Exports
exports.locals = {
	"primary-dark": "#e73b05",
	"primary": "#ff6040",
	"primary-light": "#ffe4df",
	"primary-extra-light": "#fff2f0",
	"secondary-dark": "#8292b1",
	"secondary": "#99a8c6",
	"secondary-light": "#d0dae9",
	"secondary-extra-light": "#eef4fc",
	"default-dark": "#898ca7",
	"default": "#b8baca",
	"default-light": "#ecedf5",
	"default-extra-light": "#f8f8f8",
	"warning-dark": "#d96800",
	"warning": "#fbab00",
	"warning-light": "#ffeba3",
	"warning-extra-light": "#fff5d1",
	"info-dark": "#0a82c6",
	"info": "#2eb6ea",
	"info-light": "#beebfc",
	"info-extra-light": "#dff5fe",
	"success-dark": "#069941",
	"success": "#3aaa35",
	"success-light": "#c6f1c3",
	"success-extra-light": "#e3f9e1",
	"danger-dark": "#cd0101",
	"danger": "#ff4141",
	"danger-light": "#ffcece",
	"danger-extra-light": "#ffe7e7",
	"text-primary": "#131a4f",
	"text-secondary": "#8292b1",
	"shadow-25": "rgba(184,186,202,0.25)",
	"shadow-50": "rgba(184,186,202,0.5)",
	"progressBar": "wYfcNQ0q2BtMVa6uUysSV",
	"value": "_10ppHYncH43r-aCeyQL8ej",
	"completed": "DVIOK4gHZYPNR9eawSG2m",
	"bar": "_17GIJnwlTJLqnj3f8ucG__",
	"correct": "Cwn2rKtnmjwQXNgFAogDM",
	"incorrect": "_2lBAg9wc3mNukRQnv_CLif"
};
module.exports = exports;
